// Module
var code = "<supplier-articles supplier-id=\"vm.supplier.id\"> </supplier-articles>\n";
// Exports
module.exports = code;